import React, { useState, useEffect } from 'react'
import API from '../utils/api';
import { useParams } from "react-router-dom";
import Card from 'react-bootstrap/Card';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PagarCuotaModal from '../ventas/PagarCuotaModal'
import { formatearFecha } from '../utils/FormatearFecha';
import ActualizarFechaPagoModal from '../ventas/ActualizarFechaPagoModal';
import { Cash, ArrowClockwise } from 'react-bootstrap-icons';
import { Button, Container, Row, Col, FormGroup, Table } from 'react-bootstrap';
import { Input, Label } from "reactstrap";
const DetalleVenta = () => {

    const navigate = useNavigate();
    var url = API.urlAPI
    const urlVenta = url + "ventas"
    const urlVentaDetalle = url + "ventacuotasdetalles"
    const [modal, setModal] = useState(false);
    const [modalFecha, setModalFecha] = useState(false);
    const [detalle, setDetalle] = useState({});

    const [ventas, setVentas] = useState([]);
    const [ventasDetalle, setVentasDetalle] = useState([]);
    const { IdVenta } = useParams();

    const getVentaDetalle = async () => {
        await fetch(
            urlVentaDetalle + "/" + IdVenta
        )
            .then((r) => r.json())
            .then((ventasDetalle) => setVentasDetalle(ventasDetalle))
        console.log("Detalle Ventas: ", ventasDetalle);
        console.log("Se ejecuto La venta detalle get")


    }
    useEffect(() => {

        const getVenta = async () => {
            const { data } = await axios(
                urlVenta + "/" + IdVenta
            )
            setVentas(data)
            console.log("Venta => ", data)

        }
        getVenta()

    }, [])




    const ContainerStyle = {
        boxShadow: '1px 2px 9px white',
        background: 'white'
    };

    // Funcion para el modal
    const handleSubmit = (e, item) => {
        setDetalle(item)
        console.log(detalle)
        setModal(true)
    }
    const handleSubmitFecha = (e, item) => {
        setDetalle(item)
        console.log(detalle)
        setModalFecha(true)
    }


    const getColor = (estadoFila) => {
        if (estadoFila == "Pago Completo") return '#77dd77';
        
        if (estadoFila == "Atrasado") return '#ff6961';
        if (estadoFila == "Proximo a vencer") return '#ecab74';
        if (estadoFila == "Finalizado") return '#03C03C';
        return '';
    };

    useEffect(() => {
        getVentaDetalle()
    }, [])
    return (
        <>
            <Container>
                {modal &&
                    <PagarCuotaModal
                        modal={modal}
                        setModal={setModal}
                        detalle={detalle}
                        getVentaDetalle={() => { getVentaDetalle() }}


                    ></PagarCuotaModal>
                }
                {modalFecha &&
                    <ActualizarFechaPagoModal
                        modalFecha={modalFecha}
                        setModalFecha={setModalFecha}
                        detalle={detalle}
                        getVentaDetalle={() => { getVentaDetalle() }}


                    ></ActualizarFechaPagoModal>
                }
                <Card style={ContainerStyle} >
                    <Card.Header style={{ background: "#005187", color: "white" }}><h3>Venta Cabecera</h3></Card.Header>
                    <Card.Body style={{ textAlign: "center" }}>
                        <Row>
                            <Col sm={4}>
                                <FormGroup >
                                    <Label>Fecha Alta:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={formatearFecha(ventas.FechaAlta)} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                                <FormGroup>
                                    <Label>Numero Venta:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={ventas.IdVenta} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                                <FormGroup>
                                    <Label>Modalidad:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={ventas.ModalidadDescripcion} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={4}>
                                <FormGroup>
                                    <Label>Cliente:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={ventas.Cliente} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                                <FormGroup>
                                    <Label>Cantidad Cuotas:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={ventas.CantCuotas} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                                <FormGroup>
                                    <Label>Estado Venta:</Label>
                                    <Input style={{ background: getColor(ventas.Estado), color: "white",  textAlign: "center" }} bsSize="sm" disabled value={ventas.Estado} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={4}>
                                <FormGroup>
                                    <Label>Importe Venta:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={ventas.ImporteVenta} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                                <FormGroup>
                                    <Label>Interes:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={ventas.TasaInteres} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                                <FormGroup>
                                    <Label>Importe Total:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={ventas.ImporteTotal} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                            <FormGroup>
                                    <Label>Medio de pago:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center" }} disabled value={ventas.medioPago} />
                                </FormGroup>
                                </Col>
                                <Col sm={4}>
                            <FormGroup>
                                    <Label>Adelanto:</Label>
                                    <Input bsSize="sm" style={{ textAlign: "center", background: "red", color: "white" }} disabled value={ventas.adelanto} />
                                </FormGroup>
                                </Col>
                        </Row>
                        <br></br>
                        <br></br>
                        <Container>
                            <Table reponsive bordered style={{ background: "#74a7e4", color: "white" }}>
                                <thead>
                                    <tr>
                                        <th>Producto</th>
                                        <th>Cantidad</th>
                                        <th>PrecioCosto</th>
                                        <th>PrecioVenta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        (ventas.ventadetalles == undefined) ? (
                                            <tr><td colSpan={4}>Sin productos</td></tr>
                                        ) : (
                                            ventas.ventadetalles.map((item) => (
                                                <tr key={item.Linea}>
                                                    <td>{item.Producto}</td>
                                                    <td>{item.Cantidad}</td>
                                                    <td>{item.PrecioCosto}</td>
                                                    <td>{item.PrecioVenta}</td>
                                                </tr>
                                            ))
                                        )
                                    }

                                </tbody>
                            </Table>
                        </Container>
                    </Card.Body>
                </Card>


                <br></br>
                <Card style={ContainerStyle} >
                    <Card.Header style={{ background: "#005187", color: "white" }}><h3>Venta Detalle</h3></Card.Header>
                    <Card.Body>
                        <br></br>

                        <Table responsive >
                            <thead style={{ background: "#74a7e4", color: "white" }}>
                                <tr>
                                    <th>Reg Pago</th>
                                    <th>Modif. Fecha Pago</th>
                                    <th>N° Venta</th>
                                    <th>Cuota</th>
                                    <th>Estado</th>
                                    <th>Cuota Original</th>
                                    <th>Cuota Con Interes</th>
                                    <th>Monto Pago</th>
                                    <th>Fecha de Pago</th>
                                    <th>Fecha de Vencimiento</th>
                                    <th>Registro de Pago</th>
                                    <th>Medio de Pago</th>
                                </tr>
                            </thead>
                            <tbody>
                                {

                                    (ventasDetalle.length < 1) ? (
                                        <tr>
                                            <td colSpan="11" style={{ background: "#03C03C", color: "white" }}><span>Venta Realizada al contado</span></td>
                                        </tr>
                                    ) :
                                        (
                                            ventasDetalle.map((item) =>

                                                <tr key={item.IdVentaCuota} style={{ background: getColor(item.Estado) }}>
                                                    <td style={{ minWidth: 100 }}>
                                                        <Button variant='outline-success' disabled={item.Estado === "Pago Completo"} onClick={(e) => handleSubmit(e, item)}><Cash size={25} /></Button>

                                                    </td>
                                                    <td style={{ minWidth: 100 }}>
                                                        <Button variant='outline-dark' disabled={item.Estado === "Pago Completo"} onClick={(e) => handleSubmitFecha(e, item)}><ArrowClockwise size={25} /></Button>

                                                    </td>
                                                    <td>{item.IdVenta}</td>
                                                    <td>{item.Cuota}</td>
                                                    <td>{item.Estado}</td>
                                                    <td>{item.CuotaOriginal}</td>
                                                    <td>{item.CuotaConInteres}</td>
                                                    <td>{item.MontoPago}</td>
                                                    <td>{formatearFecha(item.FechaPago)}</td>
                                                    <td>{formatearFecha(item.FechaVencimiento)}</td>

                                                    <td>{formatearFecha(item.FechaRegistro)}</td>
                                                    <td>{item.medioPago}</td>
                                                </tr>
                                            ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}

export default DetalleVenta